import HttpService from '~/zf/frontend/common/http/HttpService';
import PartnerInformationEndpoint from './PartnerInformationEndpoint';

async function getMessages() {
  const response = await HttpService.get(
    PartnerInformationEndpoint.GET_MESSAGES_FOR_USER,
  );
  return response.data;
}

function updateMessage(messageId) {
  return HttpService.get(
    PartnerInformationEndpoint.MARK_MESSAGE_AS_READ,
    { params: { messageId } },
  );
}

export default {
  getMessages,
  updateMessage,
};
